import Axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import SlotElement from "./SlotElement";

const MainFestSlotting = () => {
  const { id } = useParams();
  const [participants, setParticipants] = useState([]);
  const [masterParticipants, setMasterParticipants] = useState([]);
  const [givenSlot, setGivenSlot] = useState([]);
  const [disabled, setDisabled] = useState(false);
  const [competition, setCompetition] = useState({});
  const [level, setLevel] = useState("");
  const navigate = useNavigate();

  const [slot, setSlot] = useState({ id: "", slotNumber: 0 });

  const fetchCompiDetails = () => {
    Axios.get(
      `https://ashish.moodi.org/competitions/get_compi_details?id=${id}`
    )
      .then((res) => setCompetition(res.data))
      .catch((err) => console.error(err));
  };

  const getParticipants = () => {
    Axios.get(
      `https://ashish.moodi.org/competitions/get_participants_slot?id=${id}`
    )
      .then((res) => {
        setMasterParticipants(res.data);
        setParticipants(res.data);
      })
      .catch((err) => console.error(err));
  };

  const fetchSlottedParticipants = () => {
    Axios.get(`https://ashish.moodi.org/competitions/get_participants?id=${id}`)
      .then((res) => setGivenSlot(res.data))
      .catch((err) => console.error(err));
  };

  const onSubmitClick = () => {
    setDisabled(true);
    if (level === "") {
      if (competition.isTeamCompi) {
        Axios.post(
          "https://ashish.moodi.org/competitions/compi_slotting",
          {
            id: slot.id,
            slotNumber: slot.slotNumber,
            competition: id,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
          .then((res) => {
            if (res.data.status === "done") {
              setGivenSlot([
                ...givenSlot.slice(
                  0,
                  givenSlot.indexOf(
                    givenSlot.find(
                      (element) => res.data.slot.slotNumber < element.slotNumber
                    )
                  )
                ),
                res.data.slot,
                ...givenSlot.slice(
                  givenSlot.indexOf(
                    givenSlot.find(
                      (element) => res.data.slot.slotNumber < element.slotNumber
                    )
                  )
                ),
              ]);
              window.alert("Slot given successfully!");
              setSlot({ id: "", slotNumber: 0 });
              setDisabled(false);
            }
          })
          .catch((err) => console.error(err));
      } else {
        Axios.post(
          "https://ashish.moodi.org/competitions/compi_slotting",
          {
            id: slot.id,
            slotNumber: slot.slotNumber,
            competition: id,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
          .then((res) => {
            if (res.data.status === "done") {
              setGivenSlot([
                ...givenSlot.slice(
                  0,
                  givenSlot.indexOf(
                    givenSlot.find(
                      (element) => res.data.slot.slotNumber < element.slotNumber
                    )
                  )
                ),
                res.data.slot,
                ...givenSlot.slice(
                  givenSlot.indexOf(
                    givenSlot.find(
                      (element) => res.data.slot.slotNumber < element.slotNumber
                    )
                  )
                ),
              ]);
              window.alert("Slot given successfully");
              setSlot({ id: "", slotNumber: 0 });
              setDisabled(false);
            }
          })
          .catch((err) => console.error(err));
      }
    } else if (level === "semis") {
      if (competition.isTeamCompi) {
        Axios.post(
          "https://ashish.moodi.org/competitions/compi_semis_slotting",
          {
            id: slot.id,
            slotNumber: slot.slotNumber,
            competition: id,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
          .then((res) => {
            if (res.data.status === "done") {
              setGivenSlot([
                ...givenSlot.slice(
                  0,
                  givenSlot.indexOf(
                    givenSlot.find(
                      (element) => res.data.slot.slotNumber < element.slotNumber
                    )
                  )
                ),
                res.data.slot,
                ...givenSlot.slice(
                  givenSlot.indexOf(
                    givenSlot.find(
                      (element) => res.data.slot.slotNumber < element.slotNumber
                    )
                  )
                ),
              ]);
              window.alert("Slot given successfully!");
              setSlot({ id: "", slotNumber: 0 });
              setDisabled(false);
            }
          })
          .catch((err) => console.error(err));
      } else {
        Axios.post(
          "https://ashish.moodi.org/competitions/compi_semis_slotting",
          {
            id: slot.id,
            slotNumber: slot.slotNumber,
            competition: id,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
          .then((res) => {
            if (res.data.status === "done") {
              setGivenSlot([
                ...givenSlot.slice(
                  0,
                  givenSlot.indexOf(
                    givenSlot.find(
                      (element) => res.data.slot.slotNumber < element.slotNumber
                    )
                  )
                ),
                res.data.slot,
                ...givenSlot.slice(
                  givenSlot.indexOf(
                    givenSlot.find(
                      (element) => res.data.slot.slotNumber < element.slotNumber
                    )
                  )
                ),
              ]);
              window.alert("Slot given successfully");
              setSlot({ id: "", slotNumber: 0 });
              setDisabled(false);
            }
          })
          .catch((err) => console.error(err));
      }
    } else if (level === "finals") {
      if (competition.isTeamCompi) {
        Axios.post(
          "https://ashish.moodi.org/competitions/compi_finals_slotting",
          {
            id: slot.id,
            slotNumber: slot.slotNumber,
            competition: id,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
          .then((res) => {
            if (res.data.status === "done") {
              setGivenSlot([
                ...givenSlot.slice(
                  0,
                  givenSlot.indexOf(
                    givenSlot.find(
                      (element) => res.data.slot.slotNumber < element.slotNumber
                    )
                  )
                ),
                res.data.slot,
                ...givenSlot.slice(
                  givenSlot.indexOf(
                    givenSlot.find(
                      (element) => res.data.slot.slotNumber < element.slotNumber
                    )
                  )
                ),
              ]);
              window.alert("Slot given successfully!");
              setSlot({ id: "", slotNumber: 0 });
              setDisabled(false);
            }
          })
          .catch((err) => console.error(err));
      } else {
        Axios.post(
          "https://ashish.moodi.org/competitions/compi_finals_slotting",
          {
            id: slot.id,
            slotNumber: slot.slotNumber,
            competition: id,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
          .then((res) => {
            if (res.data.status === "done") {
              setGivenSlot([
                ...givenSlot.slice(
                  0,
                  givenSlot.indexOf(
                    givenSlot.find(
                      (element) => res.data.slot.slotNumber < element.slotNumber
                    )
                  )
                ),
                res.data.slot,
                ...givenSlot.slice(
                  givenSlot.indexOf(
                    givenSlot.find(
                      (element) => res.data.slot.slotNumber < element.slotNumber
                    )
                  )
                ),
              ]);
              window.alert("Slot given successfully");
              setSlot({ id: "", slotNumber: 0 });
              setDisabled(false);
            }
          })
          .catch((err) => console.error(err));
      }
    }
  };

  const onChange = (e) => {
    setSlot({ ...slot, [e.target.name]: e.target.value });
  };

  const onLevelChange = (e) => {
    setLevel(e.target.value);
    if (e.target.value === "") {
      Axios.get(
        `https://ashish.moodi.org/competitions/get_participants?id=${id}`
      )
        .then((res) => setGivenSlot(res.data))
        .catch((err) => console.error(err));
      setParticipants(masterParticipants);
    } else if (e.target.value === "semis") {
      Axios.get(
        `https://ashish.moodi.org/competitions/get_semis_participants?id=${id}`
      )
        .then((res) => setGivenSlot(res.data))
        .catch((err) => console.error(err));
      setParticipants(
        masterParticipants.filter((element) => element.inSemis === 1)
      );
    } else {
      Axios.get(
        `https://ashish.moodi.org/competitions/get_finals_participants?id=${id}`
      )
        .then((res) => setGivenSlot(res.data))
        .catch((err) => console.error(err));
      setParticipants(
        masterParticipants.filter((element) => element.inFinals === 1)
      );
    }
  };

  useEffect(() => {
    if (localStorage.getItem("compiauthtoken")) {
      getParticipants();
      fetchSlottedParticipants();
      fetchCompiDetails();
    } else {
      navigate("/admin/login");
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div className="container">
      <div className="input-group my-3">
        <h2 className="col-sm-7">{competition.competitionName} - Slotting</h2>
        <select
          name="level"
          id="level"
          className="form-select col-sm-2"
          onChange={onLevelChange}
        >
          <option value="" selected>
            Elims
          </option>
          <option value="semis">Semis</option>
          <option value="finals">Finals</option>
        </select>
      </div>

      <div className="input-group">
        <select
          name="id"
          id="id"
          className="form-select"
          onChange={onChange}
          value={slot.id}
        >
          <option value="">Select MI Number</option>
          {participants.map((participant) => {
            if (
              givenSlot.find(
                (element) =>
                  element.userTeamId === participant.crId ||
                  element.userTeamId === participant.teamId
              )
            ) {
              return <></>;
            } else {
              return (
                <option
                  value={
                    competition.isTeamCompi
                      ? participant.teamId
                      : participant.crId
                  }
                >
                  {participant.MI_NO}
                </option>
              );
            }
          })}
        </select>
        <div className="col-sm-1"></div>
        <select
          name="slotNumber"
          id="slotNumber"
          className="form-select"
          onChange={onChange}
          value={slot.slotNumber}
        >
          <option value={0}>Select Slot Number</option>
          {participants.map((participant, index) => {
            if (givenSlot.find((element) => element.slotNumber == index + 1)) {
              return <></>;
            } else {
              return <option value={index + 1}>Slot - {index + 1}</option>;
            }
          })}
        </select>
        <div className="col-sm-1"></div>
        {disabled ? (
          <button
            class="btn btn-primary col-auto"
            type="submit"
            disabled={disabled}
          >
            <span
              class="spinner-border spinner-border-sm"
              aria-hidden="true"
            ></span>
            <span role="status">Submitting</span>
          </button>
        ) : (
          <input
            type="submit"
            value="Submit"
            className="btn btn-primary col-auto"
            disabled={disabled}
            onClick={onSubmitClick}
          />
        )}
      </div>
      <h2 className="my-3">Slotted Participants</h2>
      <hr />
      <div className="row">
        <h5 className="col-sm-2">MI Number</h5>
        <div className="col-sm-1"></div>
        <h5 className="col-sm-2">Slot Number</h5>
        <h5 className="col-sm-3">Phone Number</h5>
      </div>
      <hr />
      <hr />
      {givenSlot.map((slot) => {
        return (
          <SlotElement
            slot={slot}
            competition={competition}
            participants={participants}
            level={level}
            givenSlot={givenSlot}
            setGivenSlot={setGivenSlot}
          />
        );
      })}
    </div>
  );
};

export default MainFestSlotting;
